import { NotificationsCount } from "@/api/notifications/notificationsApi";
import { EventNames } from "@/common/event-names";
import { computed, onMounted, onUnmounted, ref } from "vue"

// Хранит состояние и подписывается на обновления счетчика
export const userNotificationCounterState = () => {
    const counter = ref(0);

    const display = computed(() => {
        if (counter.value == 0) {
            return '';
        }
        if (counter.value > 99) {
            return '99+';
        }
        return `${counter.value}`;
    });

    const update = (val: number) => counter.value = val;

    const listener = (event: Event) => {
        const e = event as CustomEvent<NotificationsCount>;
        update(e.detail.count);
    }

    onMounted(() => {
        window.addEventListener(EventNames.NotificationCounterUpdated, listener);
    })

    onUnmounted(() => {
        window.removeEventListener(EventNames.NotificationCounterUpdated, listener);
    })

    return {
        display,
        counter
    }
}